module.exports = __webpack_public_path__ + "img/icon_map_xiaofangshuan_zaixian_dianji.42365e94.svg";